import React from "react";
import CheckmarkIcon from "../../Layout/Icons/CheckmarkIcon";

class Option extends React.Component {
  handleClick = () => {
    this.props.handleSelectProofOption(this.props.optionValue);
  };

  render() {
    const selected = this.props.selected === this.props.optionValue;
    const showError = this.props.showError;

    return (
      <li
        className={`proof-options__option ${selected ? "selected" : ""} ${showError ? "error" : ""}`}
        onClick={this.handleClick}
      >
        <button
          className={`button button--proof-option ${selected ? "selected" : ""} ${showError ? "error" : ""}`}
        >
          {selected && <CheckmarkIcon />}
        </button>

        <div className="proof-options__text">{this.props.children}</div>
      </li>
    );
  }
}

export default Option;
